import { takeLatest } from 'redux-saga/effects';
import { loadBetPosition } from './loadBetPosition';
import {
  CHANGE_OFFER_PRICE,
  RELOAD_BET_POSITION,
  CHANGE_AUCTION_BET,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PUBLISH_TERMS_SERVICE,
  REVERT_AUCTION_BET,
  CLEAR_AUCTION_BET,
} from '../../reducers';

export function* betPositionSagas() {
  yield takeLatest(
    [
      LOAD_PUBLISH_TERMS_SUCCESS,
      SELECT_PUBLISH_TERMS_SERVICE,
      CHANGE_OFFER_PRICE,
      RELOAD_BET_POSITION,
      CHANGE_AUCTION_BET,
      REVERT_AUCTION_BET,
      CLEAR_AUCTION_BET,
    ],
    loadBetPosition,
  );
}
